export const formContent = {
    heading: 'Change Password',
    oldPassword: {
        id: 'oldPassword',
        type: 'password',
        label: 'Old Password',
        validation: {
            required: "Enter old password"
        }
    },
    newPassword: {
        id: 'newPassword',
        type: 'password',
        label: 'New Password',
        validation: {
            required: "Enter new password"
        }
    },
    confirmPassword: {
        id: 'confirmPassword',
        type: 'password',
        label: 'Confirm password',
        validation: {
            required: "Enter confirm password"
        }
    },
    updatePasswordButton: {
        id: 'updatePasswordButton',
        label: 'Update Password',
        type: 'submit'
    },
}
